import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6
import { InputNumber } from 'antd';

class VariableNumeric extends Component {

    render() {
        const { estilsDiv, variable } = this.props;

        return (
            <div className={estilsDiv}>
                {variable.nom}
                <InputNumber
                    defaultValue={ variable.valor }
                    onChange={this.props.onChangeValorVariable}
                />
            </div>
        );
    }
}

VariableNumeric.propTypes = {
    estilsDiv: PropTypes.string,
    variable: PropTypes.object,
    onChangeValorVariable: PropTypes.func
};

export default VariableNumeric;



// WEBPACK FOOTER //
// ./src/components/commons/variableNumeric.js